module.exports = __webpack_public_path__ + "static/Principal-Black-699076d08cf1db445c1266068c5301be.woff2";